import styled from 'styled-components';
import { transparentize } from 'polished';
import { motion } from 'framer-motion';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "RadioGroupstyles__Container",
  componentId: "keen-query-creator__sc-1azn2lp-0"
})(["&&&{display:inline-flex;align-items:center;background-color:", ";border-radius:4px;position:relative;}"], transparentize(0.85, colors.blue['100']));
export var StyledLabel = styled.label.withConfig({
  displayName: "RadioGroupstyles__StyledLabel",
  componentId: "keen-query-creator__sc-1azn2lp-1"
})(["&&&{margin:0;padding:10px 14px;font-family:'Lato Regular',sans-serif;font-size:14px;line-height:17px;color:", ";cursor:pointer;}"], colors.blue['500']);
export var Radio = styled.div.withConfig({
  displayName: "RadioGroupstyles__Radio",
  componentId: "keen-query-creator__sc-1azn2lp-2"
})(["&&&{display:flex;position:relative;z-index:10;overflow:hidden;}"]);
export var StyledInput = styled.input.withConfig({
  displayName: "RadioGroupstyles__StyledInput",
  componentId: "keen-query-creator__sc-1azn2lp-3"
})(["&&&{clip:rect(0 0 0 0);clip-path:inset(100%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;}"]);
export var Marker = styled(motion.div).withConfig({
  displayName: "RadioGroupstyles__Marker",
  componentId: "keen-query-creator__sc-1azn2lp-4"
})(["&&&{position:absolute;left:0;z-index:1;border-radius:4px;background-color:", ";}"], transparentize(0.2, colors.green['100']));